import type { TenantConfig } from '@/types/TenantConfig'

export const spyscape: TenantConfig = {
  themeMode: 'dark',
  themeOptions: {
    cartHeaderBackgroundColor: 'white',
    dialog: {
      headerBackground: '#181E33',
      headerIconColor: '#4EC3F7',
    },
    mobileFooter: {
      backgroundColor: '#181E33',
      cartButtonBackgroundColor: 'transparent',
      cartButtonHoverBackgroundColor: 'transparent',
      cartButtonBorder: '1px solid #4EC3F7',
      cartButtonIconColor: '#ffffff',
    },
    backButton: {
      backgroundColor: '#4EC3F7',
      iconColor: '#000',
    },
    datePicker: {
      selectedDayBackgroundColor: '#4EC3F7',
      focusedDayBackgroundColor: '#4EC3F7',
    },
  },
  logo: 'assets/spyscape/static/logo.svg',
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/spyscape/static/completed-desktop.jpg',
        mobile: 'assets/spyscape/static/completed-mobile.jpg',
      },
      completedContentOffset: {
        desktop: '-192px',
        mobile: '-74px',
      },
    },
    cartWidget: {
      showTicketGroupName: true,
    },
    checkoutRoute: {
      stripeWallets: true,
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/spyscape/static/fonts.css',
    },
  },
}
